import { createFileRoute } from "@tanstack/react-router";
import { OAuthCallbackView } from "src/components/views/oAuthCallback/OAuthCallbackView.tsx";

export const Route = createFileRoute("/connection/oauth/callback")({
	component: OAuthCallbackView,
});
